export const AppSettings = {
  environment: process.env.REACT_APP_SETTINGS_ENVIRONMENT,
  apiUrl: process.env.REACT_APP_SETTINGS_API_URL,
  bdsName: "Bureau of Disabilities Services",
  bdsAcronym: "BDS",
  Link_DistrictOffices: "https://www.in.gov/fssa/ddars/bds/bureau-of-disabilities-services/",
  Link_DDRSLanding: "https://www.in.gov/fssa/ddars/bds/developmental-disabilities/",
  Link_DDRSForms: "https://www.in.gov/fssa/ddars/resources/individuals/forms/",
  Link_FSWChecklist: "https://www.in.gov/fssa/ddars/files/FSW_Checklist.pdf",
  activityPulseInterval: 10000,
  fatalErrorBannerThreshold: 30000,
  autoLogoutNotificationWindowInSeconds: 120,
  maxUploadFileSize: 40000000,
  validUploadFileFormats: [".bmp",".jpg",".jpeg",".gif",".png",".tif",".tiff",".pdf",".doc",".docx"],
  ageDateRangeRestriction: 130
}